<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">角色管理</li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('154')"
        >添加</el-button
      >
    </ul>
    <ul class="c-list-search">
      <el-input
        v-model="state.params.name"
        style="width: 200px"
        placeholder="--关键字--"
        clearable
        @clear="
          delete state.params.name;
          onLoad();
        "
      ></el-input>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态"
          prop="status"
          sortable="status"
          width="100"
          fixed="left"
        >
          <template #default="{ row }">
            <el-switch
              v-model="row.status"
              inline-prompt
              active-text="启用"
              active-color="#1e90ff"
              inactive-text="停用"
              inactive-color="#f00"
              :active-value="1"
              :inactive-value="0"
              style="--el-switch-off-color: #f00"
              @change="onChangeQt(row)"
              :disabled="!$judge_auth('157')"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          sortable="name"
          label="名称"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
        />
        <el-table-column
          prop="description"
          label="角色说明"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="create_time"
          sortable="create_time"
          label="创建时间"
        />
        <el-table-column
          prop="update_time"
          sortable="update_time"
          label="修改时间"
        />
        <el-table-column
          label="操作"
          width="360"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth(['155', '156', '523', '550'])"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              v-if="$judge_auth('155')"
            >
              编辑
            </el-button>
            <el-button
              type="primary"
              link
              icon="Unlock"
              @click="onShowAuthorize(row.id)"
              v-if="$judge_auth('523')"
            >
              授权
            </el-button>
            <el-button
              type="primary"
              link
              icon="Connection"
              @click="
                state.selectId = row.id;
                state.showYh = true;
              "
              v-if="$judge_auth('550')"
            >
              绑定用户
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
              v-if="$judge_auth('156')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '角色'"
        @close="state.showInfo = false"
      >
        <c_AdminRoleInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_AdminRoleInfo>
      </c_popup>
    </transition>
    <el-drawer
      v-model="state.showYh"
      :with-header="false"
      size="80%"
      titile="绑定用户"
    >
      <c_AdminRoleBindYh
        :id="state.selectId"
        @close="state.showYh = false"
        v-if="state.showYh"
      ></c_AdminRoleBindYh>
    </el-drawer>
    <el-drawer
      v-model="state.showQx"
      :key="state.key"
      :with-header="false"
      size="80%"
    >
      <c_AdminRoleSetQx
        :id="state.selectId"
        @close="state.showQx = false"
      ></c_AdminRoleSetQx>
    </el-drawer>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { role_list, role_delete, role_qt } from "@/http/adminrole";
import { ElMessageBox, ElMessage } from "element-plus";
import { confirm_func } from "@/utils/qFormat";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      role_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //启停
    const onChangeQt = (row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 0
            ? '<strong style="color:#f00">停用'
            : '<strong style="color:#1e90ff">启用'
        }</strong>该角色吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          role_qt(row).then((res) => {
            if (res.status == 200)
              ElMessage({
                type: "success",
                grouping: true,
                message: res.data.msg,
              });
          });
        })
        .catch(() => {
          row.status = row.status == 1 ? 0 : 1;
        });
    };

    //配置权限
    const onShowAuthorize = (id) => {
      state.key = Math.random();
      state.showQx = true;
      state.selectId = id;
    };

    //删除
    const onDelete = (id) => {
      confirm_func(role_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onChangeQt,
      onShowAuthorize,
      onDelete,
    };
  },
};
</script>
<style scoped></style>
